export const clearAuth = () => {
  localStorage.removeItem("apiToken");
  localStorage.removeItem("user");
  localStorage.removeItem("isValidToken");
};

export const persistAuth = (user, token) => {
  localStorage.setItem("user", JSON.stringify(user));
  localStorage.setItem("apiToken", token);
};

export const getAuthenticatedUser = () => {
  return localStorage.getItem("user");
};

export const getToken = () => {
  return localStorage.getItem("apiToken");
};

export const getTokenValidStatus = () => {
  return JSON.parse(localStorage.getItem("user"))?.isValidToken;
};

export const getQrCode = () => {
  return JSON.parse(localStorage.getItem("user"))?.qrCode;
};

export const clearQrCode = () => {
  const userJson = JSON.parse(localStorage.getItem("user"));

  delete userJson["qrCode"];

  localStorage.setItem("user", JSON.stringify(userJson));
};
